import { IonNote, IonActionSheet, IonRippleEffect, IonModal, IonList, IonPopover, useIonRouter, useIonViewWillLeave, IonFooter, IonChip, useIonViewDidEnter, IonInfiniteScrollContent, IonInfiniteScroll, IonText, IonThumbnail, IonBadge, IonImg, IonTextarea, IonProgressBar, IonAlert, IonGrid, IonRow, IonCol, IonCardTitle, IonCardSubtitle, IonCardHeader, IonCardContent, IonAvatar, IonToast, useIonViewWillEnter, IonIcon, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useRef, Component, useState, useEffect }  from 'react';
import { RouteComponentProps } from "react-router-dom";
import { cashOutline, chatboxEllipsesOutline, trashBinOutline, lockOpenOutline, lockClosedOutline, createOutline, copyOutline, close, arrowRedoOutline, peopleOutline, imagesOutline, banOutline, trashOutline, listOutline, ellipsisVertical, walletOutline, imageOutline, closeOutline, personAdd, addOutline, sendOutline } from "ionicons/icons";
import { Keyboard } from '@capacitor/keyboard';
import { Camera, CameraResultType } from '@capacitor/camera';
import { Clipboard } from '@capacitor/clipboard';
import { Virtuoso, VirtuosoHandle } from 'react-virtuoso';

import '../pages/Main.css';
import '../pages/ChatMsg.css';

import { showTab, hideTab } from "../components/Tabs";
import { LANGUAGE, GetStr } from "../language/Language";
import { Storage } from '@capacitor/storage';   
import NServer, { handleRouteError, RegisterAppServices } from "../components/NServer";
import Vault from '../components/Vault';

import { MsgData, MsgDataGroup, MsgUser } from "../data/message";
import ChatMsgGroup from "../components/ChatMsgGroup";
import { showAlert } from '../components/Alert';
import GifContent, { LoadGifs, GifData } from "../components/GifContent";
import LikeErrComp from "../components/LikeErrComp";
import { ReadyAds, ShowAds } from "../components/Admob";
import PaymentDlg from "../components/PaymentDlg";
import { checkPasscode } from '../components/PassCheckCtrl';

var chat_type : string = "";
var block_user : number = -1;
var block_type : string = "";
var typed_msg : string = "";


interface ChatInputProp {
    id : any,
    type : string,
    thread : number,
    need_join : boolean,
    replied_msg : any,
    block : boolean,
    max_images : any,
    total_images : any,
    minWords : any,
    email : string,
    updateChat : any,
    chatType : string,
    closed : boolean
}

const ChatInput : React.FC<ChatInputProp> = ({ id, type, thread, need_join, replied_msg, block, 
                                               max_images, total_images, minWords, 
                                               email, updateChat, chatType, closed }) => {

    // join info
    const [needJoin, setNeedJoin] = useState(false);
    useEffect(() => { setNeedJoin(need_join) }, [need_join]);

    // reply msg
    const [repliedMsg, setRepliedMsg] = useState<any>(null);
    useEffect(() => { setRepliedMsg(replied_msg) }, [replied_msg]);

    // block info
    const [blocked, setBlocked] = useState(false);
    useEffect(() => { setBlocked(block) }, [block]);

    const [addOption, showAddOption] = useState(false);
    const [gif, setGif] = useState(false);
    const [gifData, setGifData] = useState<GifData>({ categories:[], gifs:[], cached_gifs:[] });
    const [canSend, setCanSend] = useState(false);
    const inputRef = useRef<HTMLIonTextareaElement | null>(null);
    const [msg, setMsg] = useState("");
    const [totalWords, setTotalWords] = useState(0);
    const [payment, showPayment] = useState(false);

    //	Initializing our router
	const router = useIonRouter();

    // need to refresh
    useEffect(() => {
        // init
        typed_msg = "";
    },[id]);

    // join the group chat
    const joinGroupChat = async () => {
        setNeedJoin(false);

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            to: id,
            type : type
        }

		var server = new NServer();
        await server.sendForm("nc_join_msg", state);
    }

    // send gif
    const processSendGif = async (gif : string) => {
        setGif(false);
        showAddOption(false);

        if (gif == "")
            return;
        // check for minimum image count
        if (max_images > 0 && total_images >= max_images)
            return;

        let ref = -1;
        if (repliedMsg != null)
            ref = repliedMsg.id;
        setRepliedMsg(null);

        // upload image
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            to: id,
            type : type,
            msg : gif,
            email: email,
            ref: ref
        }

		var server = new NServer();
        await server.sendForm("nc_send_msg_gif", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            if (id < 0)
            {
                // refresh to new thread
                let thread = server.data.thread;
                router.push("/chatmsg/" + thread + "/thread", "back", "pop");
                window.location.reload();
            }
            else
            {
                // refresh UI
                updateChat();
            }

            setCanSend(false);
            if (inputRef.current != null)
                inputRef.current.value = "";
        }
    }

    // show the gif
    const showGif = () => {
        if (max_images > 0 && total_images >= max_images)
            return;

        setGif(true);
        loadGif(0);
    }

    // load the gif
    const loadGif = async (cat : number) => {
        // clear first
        setGifData({ categories: gifData.categories, gifs:[], cached_gifs:[] });

        // load
        let gifs : GifData = await LoadGifs(cat);
        setGifData(gifs);
    }

    // add image to message
    const addImg = async () => {
        if (thread < 0)
            return;

        // check for minimum image count
        if (max_images > 0 && total_images >= max_images)
            return;

        const image = await Camera.getPhoto({
            quality: 90,
            allowEditing: false,
            resultType: CameraResultType.Uri
        });

        // image.webPath will contain a path that can be set as an image src.
        // You can access the original file using image.path, which can be
        // passed to the Filesystem API to read the raw data of the image,
        // if desired (or pass resultType: CameraResultType.Base64 to getPhoto)
        var imageUrl = image.webPath;
        if (imageUrl == undefined)
            return;

        // upload image
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            name: thread,
            type: "mimg"
        }

        var server = new NServer();
        await server.uploadImage(imageUrl, state);

        if (!server.success && server.message != "")
            showAlert(server.message);
    }

    // send money
    const sendMoney = async () => {
        let passOK = await checkPasscode(router);

        if (passOK)
            showPayment(true);
    }

    const processSendMsg = (e : any) => {
        if (inputRef.current != null)
        {
            if (e.clientX >= inputRef.current.getBoundingClientRect().right)
            {
                // trigger the button
                sendMsg();
            }
        }
    }

    // send the message
    const sendMsg = async () => {
        if (msg == "")
            return;
        // check for minimum word count
        if (minWords > 0 && totalWords < minWords)
            return;

        let v = new Vault();
        await v.read();

        let ref = -1;
        if (repliedMsg != null)
            ref = repliedMsg.id;
        setRepliedMsg(null);

        const state = {
            id: v.account.id,
            pass: v.account.key,
            to: id,
            type : type,
            msg : msg,
            email: email,
            ref: ref
        }

        var server = new NServer();
        await server.sendForm("nc_send_msg", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            if (id < 0)
            {
                // refresh to new thread
                let thread = server.data.thread;
                router.push("/chatmsg/" + thread + "/thread", "back", "pop");
                window.location.reload();
            }
            else
            {
                // refresh UI
                updateChat();
            }

            setCanSend(false);
            if (inputRef.current != null)
                inputRef.current.value = "";
        }
    }

    // update the message
    const updateMsg = (val : string) => {
        if (val != '')
            setCanSend(true);
        else
            setCanSend(false);

        let msg = val.replace(/\s/g, "");
        setTotalWords(msg.length);

        setMsg(val);
        typed_msg = val;
    }

    // submit the money to the other user
    const submitMoney = async (amount : number, passKey : string) => {
        let v = new Vault();
        await v.read();

        // send money sent message
        const state = {
            id: v.account.id,
            pass: v.account.key,
            lock: passKey,
            to: id,
            type : type,
            amount: amount
        }

        var server = new NServer();
        await server.sendForm("nc_send_msg_money", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
            updateChat();
    }

    return (
        <div className="chat-input-box">
           {
                // need to join the chat
                needJoin ?
            <div className="bk-panel">
                <IonButton className="main-but" expand="block" color="secondary" onClick={ joinGroupChat }>
                    { GetStr(LANGUAGE.TXT_CHAT_JOIN_GROUP) }
                </IonButton>
            </div>
                :
            <div/>
            }

            { /* reply message */ }
            {
                repliedMsg != null ?
            <div>
                <IonToolbar className="reply-bar">
                    <IonLabel color="primary"><small><b>{ GetStr(LANGUAGE.TXT_CMT_REPLYING_TO) }</b></small></IonLabel>
                    <IonButton slot="end" fill="clear" onClick={ () => setRepliedMsg(null) }>
                        <IonIcon icon={closeOutline} />
                    </IonButton>
                </IonToolbar>
                <div className="reply-box">
                    <IonText color="medium">
                        <b>{ repliedMsg.name }</b>
                        <div className="reply-comment">{ repliedMsg.msg }</div>
                    </IonText>
                </div>
            </div>
                :
            <div/>
            }
            {/* bottom message input */}
            {
                closed ?
            <div className="wrapper">
                <IonItem lines="none">
                    <IonIcon slot="start" icon={banOutline}></IonIcon>
                    <IonLabel>{ GetStr(LANGUAGE.TXT_MSG_CHANNEL_CLOSED) }</IonLabel>
                </IonItem>
            </div>
                :
                !blocked ?
            <div className="wrapper">
                {
                    /* image options */
                    addOption && gif ?
                <GifContent content={gifData} onSend={processSendGif} onHide={ ()=>setGif(false) } onChange={loadGif}></GifContent>
                    :
                    addOption ?
                <IonToolbar>
                    <IonButtons>
                        <IonButton color="primary" onClick={addImg} disabled={thread<0}>
                            <IonIcon icon={imageOutline}></IonIcon>&nbsp;
                            { GetStr(LANGUAGE.TXT_CHAT_UPLOAD_IMG) }
                        </IonButton>
                        <IonButton color="primary" onClick={showGif} disabled={thread<0}>
                            <IonIcon icon={imagesOutline}></IonIcon>&nbsp;
                            { GetStr(LANGUAGE.TXT_CHAT_SEND_GIF) }
                        </IonButton>

                        {
                            /* in normal chat mode, you can send money */
                            chatType == "" ?
                        <IonButton color="primary" onClick={sendMoney} >
                            <IonIcon icon={cashOutline}></IonIcon>&nbsp;
                            { GetStr(LANGUAGE.TXT_CHAT_SEND_MONEY) }
                        </IonButton>
                            :
                        <div/>
                        }
                    </IonButtons>
                    {
                        max_images > 0 ?
                    <IonLabel className="ion-margin-end" slot="end">{total_images} / {max_images}</IonLabel>
                        :
                    <div/>
                    }
                </IonToolbar>
                    :
                <div/>
                }
                {
                    /* minimum words limit */
                    minWords > 0 ?
                <div>
                    <IonText color="medium">
                        <small className="ion-float-right ion-margin-end">{ GetStr(LANGUAGE.CHAT_MSG_MIN_WORDS) + totalWords + " / " + minWords }</small>
                    </IonText>
                </div>
                    :
                <div/>
                }
                <div className="message">
                        
                    {
                        addOption ?
                    <IonButton className="action" color="primary" fill="clear" onClick={()=> showAddOption(false)}>
                        <IonIcon icon={closeOutline}></IonIcon>
                    </IonButton>  
                        :
                    <IonButton className="action" color="primary" fill="clear" onClick={()=> showAddOption(true)}>
                        <IonIcon icon={addOutline}></IonIcon>
                    </IonButton>  
                    }
                    <IonItem className="msg-box" onClick={e => processSendMsg(e) } lines="none">
                        <IonTextarea className="msg-textarea" id="input-msg" ref={inputRef} rows={1} auto-grow maxlength={500} placeholder={ GetStr(LANGUAGE.TXT_CHAT_TYPE) } onIonChange={e => updateMsg(e.detail.value!)}></IonTextarea>
                        <IonIcon className="icon-but" slot="end" color={ (minWords > 0 && totalWords < minWords) ? "medium" : "primary" } icon={sendOutline}></IonIcon>
                    </IonItem>
                </div>
            </div>
                :
            <div className="wrapper">
                <IonItem lines="none">
                    <IonIcon slot="start" icon={banOutline}></IonIcon>
                    <IonLabel>{ GetStr(LANGUAGE.TXT_CANT_SEND_MSG) }</IonLabel>
                </IonItem>
            </div>
            }

            { /* payment dialog box */ }
            <PaymentDlg 
                show={payment} 
                dismiss={ ()=> showPayment(false) }
                title={ GetStr(LANGUAGE.TXT_SEND_PAYMENT_CAP) }
                cap={ GetStr(LANGUAGE.TXT_SEND_AMOUNT_LBL) }
                desc={ GetStr(LANGUAGE.TXT_DO_SEND_BUT) } 
                submit={submitMoney}
            >
            </PaymentDlg>
        </div>
    );
};
  
export default ChatInput;